import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import React, { useState } from 'react';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import { makeStyles } from 'tss-react/mui';
import { Collapse, IconButton } from '@mui/material';
import { MAIN_THEME } from '@styles';
import EnhancedButton from '../_old/EnhancedButton';

interface ICollapsavleSectionProps extends IFormFieldInputBaseProps {
  title: string;
  open?: boolean;
  className?: string;
  classes?: { header?: string; content?: string };
  children?: React.ReactNode;
  actions?: JSX.Element;
  onButtonClick?: () => void;
}

const useStyles = makeStyles()(() => ({
  container: {
    width: '100%',
    fontFamily: `${MAIN_THEME.font.bold} !important`,
    fontSize: `${MAIN_THEME.fontSize.md} !important`,
  },
  header: {
    cursor: 'pointer',
    fontSize: `${MAIN_THEME.fontSize.md} !important`,
    lineHeight: '27px',
    color: MAIN_THEME.color.black47,
    '&:hover': {
      color: 'black',
    },
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
    background: 'unset',
    border: 'none',
    width: '5000px',
  },
  content: {
    padding: '0px 12px 12px 44px',
  },
  collapse: {
    transform: 'rotate(0deg)',
    transition: '150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  collapseOpen: {
    transform: 'rotate(180deg)',
  },
  actions: {
    width: '20%',
    height: '50px',
    textAlign: 'center',
    backgroundColor: 'black',
    color: 'white',
  },
}));

const CollapsibleSection: React.FC<ICollapsavleSectionProps> = ({
  title,
  open,
  className,
  classes = {},
  children,
  actions,
  onButtonClick,
}) => {
  const { classes: collapsableClasses } = useStyles();
  const [collapse, setCollapse] = useState(!!open);

  function toggleCollapse() {
    setCollapse(!collapse);
  }

  return (
    <div className={collapsableClasses.container}>
      <div
        role="presentation"
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <IconButton
            aria-label={'Show More'}
            className={clsx(collapsableClasses.collapse, {
              [collapsableClasses.collapseOpen]: collapse,
            })}
            onClick={toggleCollapse}
          >
            <ExpandMoreIcon />
          </IconButton>
          {title}
        </div>
        {actions && (
          <EnhancedButton
            type="button"
            backgroundColor={MAIN_THEME.color.black}
            color={'white'}
            onClick={onButtonClick}
          >
            {'Modify'}
          </EnhancedButton>
        )}
      </div>
      <Collapse
        in={collapse}
        timeout={150}
        className={clsx(collapsableClasses.content, classes.content)}
        classes={
          className
            ? {
                wrapperInner: className,
              }
            : {}
        }
      >
        {/* {actions && (
          <>
            <EnhancedButton
              type="button"
              backgroundColor={MAIN_THEME.color.black}
              color={'white'}
            >
              {'Modify'}
            </EnhancedButton>
          </>
        )} */}
        {children}
      </Collapse>
    </div>
  );
};

export default CollapsibleSection;
